import React, { useEffect, useState } from "react";
import TableComponent from "../../../../components/TableComponent";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import Pagination from "../../../../components/Pagination";
import NoData from "../../../../components/NoData";
import BreadCrums from "../../../../components/BreadCrums";
import { Api, ImagePath } from "../../../../config/apiEndPoints";
import MainLayout from "../../../../layouts/MainLayout";
import InvoicePreview from "../../../../modals/InvoicePreview";
import { getServiceType } from "../../../../redux/actions/otherActions";
import UpGradePlan from "../../../../modals/UpGradePlan";
import { callApi } from "../../../../config/apiCall";
import { getAllPlans } from "../../../../redux/actions/dashBoardActions";

const PlansPage = () => {
    const dispatch = useDispatch()
    const [modalData, setModalData] = useState({ isOpen: false, data: "" })
    const isLoading = useSelector((state) => state.commenData.loading)
    const companiesData = useSelector((state) => state.commenData?.companiesData)
    const [searchText, setSearchText] = useState("")
    const [pageStats, setPageStats] = useState()
    const [planHistory, setHistory] = useState([])
    const plansData = useSelector((state) => state.commenData.allPlans)
    const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
    const [filters, setFilters] = useState({
        limit: 10,
        page: 1,
        deliver: "",
        status: "",
        sort: "",
        currentPage: 1,
    })

    const formateForPlans = companiesData?.data?.map((item) => {
        const { company_name, company_logo,
            current_plan, service_type, id, ...rest } = item
        // //console.log("item" ,item);
        return {
            company_name,
            company_logo,
            service_type,
            ...current_plan,
            id,
        }
    })


    useEffect(() => {
        dispatch(getServiceType("public/services"))
        fetchPlanHistory()
        dispatch(getAllPlans("public/plans"))

    }, [])




    const tableHeader = [
        // "Company Name",
        "#invoice",
        "Service Type",
        "Plan Name",
        "Purchase Date",
        "Expiry Date",
        "Status",
        "Amount",
    ];

    const dataKeys = [
        // "company_name",          // Company Name
        "invoice_no",          // Company Name
        "services",          // Service Type (array stored as string)
        "p_name",
        "start_date",
        "end_date",
        "status",
        "amount",
    ];
    // console.log("companiesData ₹",plansData);

    const onClose = () => {
        setModalData((prev) => ({
            ...prev,
            type: "",
            isOpen: false,
        }))
    }
    const handleActions = (data, type) => {
        //console.log(data, type);

        if (type == "pdfDownload") {
            const url = `${ImagePath}${data?.invoice_url}`;
            if (url) {
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `invoice${data?.end_date}.pdf`); // You can customize the filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error("Invoice URL not found.");
            }
        } else {
            setModalData((prev) => ({
                ...prev,
                data: { ...data, total_price: data?.amount },
                type: type,
                isOpen: true,
                onConfirm: "",
                onClose: onClose
            }))
        }
    }

    const fetchPlanHistory = async () => {
        try {
            const response = await callApi("get-company-subscription-history", "GET", "", details?.token)
            console.log(response?.data);
            if (response.authenticated && response.valid) {
                setHistory(response.data || [])
            }

        } catch (error) {
            //console.log(error);
        }
    }
    const fetchStats = async () => {
        try {
            const response = await callApi(Api.PLANSSTATS, "GET", "", details?.token)
            if (response.authenticated && response.valid) {
                // //console.log(response);
                setPageStats(response.data || {})
            }

        } catch (error) {
            //console.log(error);
        }
    }

    const handlePageChange = (page) => {
        // Call your API here to fetch data for the new page
        setFilters(prev => ({
            ...prev,
            currentPage: page,
            page: page
        }));
    };

    const changeFilter = (value, key) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value
        }))
    }

  

    return (
        <React.Fragment>
            <MainLayout>
                <div className="page-wrapper">
                    <div className="content">
                        {/* Breadcrumb */}
                        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                            <BreadCrums
                                title={"Plans History"}
                                data={[
                                    { path: "/admin/", title: "Admin" },

                                    { path: "#", title: "Plans History" },
                                ]}
                            />
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                                <div className="me-2 mb-2">

                                </div>
                                <div className="mb-2">
                                    <a
                                        onClick={() => {
                                            setModalData((prev) => ({
                                                ...prev,
                                                isOpen: true,
                                                data:planHistory?.find((pd) => { return pd.status?.toLowerCase() == "active" }),
                                                type: "upgrade",
                                                onClose: onClose
                                            }))
                                        }}
                                        className="btn btn-primary d-flex align-items-center"
                                    >
                                        Renew Plan
                                    </a>
                                </div>
                                <div className="ms-2 head-icons"></div>
                            </div>
                        </div>

                        {
                            isLoading ?
                                <Loader /> :
                                <div className="card">
                                    {
                                        !isLoading && formateForPlans?.length == 0 ? <NoData /> : <>
                                            <div className="card-header d- align-items-center justify-content-between flex-wrap row-gap-3">
                                                <h5 className="pb-3 border-bottom">Companies Plan </h5>


                                                <div class="row g-4 admin-plans-history py-3">

                                                    {/* <!-- Monthly Plan --> */}

                                                    {
                                                        plansData?.data?.map((p, i) => {
                                                            // console.log(p);
                                                            return (
                                                                <div key={i} class="col-md-4">
                                                                    <div class={`plan-card bg-${p.duration.toLowerCase()} border`}>
                                                                        <div className="p-3 rounded " style={{ background: "#F4F5F6", position: "relative" }}>
                                                                            <div>
                                                                                <div className="d-flex gap-2 align-items-center py-2 pb-3 border-bottom">
                                                                                    <span class="plan-title"><i class="ti ti-star text-white"></i> </span>
                                                                                    <h2>{p.name} <small>({p.duration})</small></h2>
                                                                                    {
                                                                                        planHistory?.find((pd) => { return pd.status?.toLowerCase() == "active" })?.plan_name == p.name &&
                                                                                        <span class="badge bg-success" style={{
                                                                                            position: "absolute",
                                                                                            bottom: "5px",
                                                                                            right: "1px",
                                                                                            fontSize: "13px"
                                                                                        }} >Current Active</span>
                                                                                    }
                                                                                </div>
                                                                                <div class="price py-2">₹{p.price}</div>
                                                                            </div>
                                                                        </div>

                                                                        <h6 class="py-4 fw-bold ">Includes:</h6>
                                                                        {
                                                                            p?.features?.map((f, fIndex) => {
                                                                                return (
                                                                                    <div class="feature-item" key={fIndex}><i class="ti ti-check"></i> {f}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>

                                            </div>

                                            <div className="row align-items-center px-3">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" >
                                                        <label>
                                                            Row per page
                                                            <select value={filters?.limit} onChange={(e) => {
                                                                changeFilter(e.target.value, "limit")
                                                            }} className="form-select form-select-sm">
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                                <option value="100">100</option>
                                                            </select>
                                                            Entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_filter m-0 text-end">
                                                        <label>
                                                            <input type="search"
                                                                className="form-control form-control-sm"
                                                                placeholder="Search"
                                                                value={searchText}
                                                                onChange={(e) => {
                                                                    setSearchText(e.target.value)
                                                                }}
                                                            />
                                                        </label></div>
                                                </div>
                                            </div>

                                            <div className="card-body sv-card-body p-3">
                                                <div className="custom-datatable-filter table-responsive">
                                                    <TableComponent
                                                        tableHeader={tableHeader}
                                                        dataSource={planHistory?.filter((item) => {
                                                            if (searchText) {
                                                                return item?.company_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
                                                                    item?.plan_name?.toLowerCase().includes(searchText?.toLowerCase())
                                                            }
                                                            return item
                                                        }) || []}
                                                        // historyLink={"/superadmin/plans-history"}
                                                        dataKeys={dataKeys || []}
                                                        pdfDownload={handleActions}
                                                    // pdfView={handleActions}
                                                    // indexStartFrom={((companiesData?.pagination?.currentPage - 1) * companiesData?.pagination?.limit + 1)||0}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                        }
                        {
                            formateForPlans?.length == 0 ? "" :
                                <Pagination pagination={companiesData?.pagination} onPageChange={handlePageChange} />
                        }
                    </div>

                </div>
            </MainLayout>

            {
                modalData.type == "addPlan" && modalData.isOpen &&
                <UpGradePlan handleData={modalData} formAdmin={true} />
            }
            {
                modalData.type == "upgrade" && modalData.isOpen &&
                <UpGradePlan handleData={modalData} formAdmin={true} />
            }
            {
                modalData.type == "pdfView" && modalData.isOpen &&
                <InvoicePreview handleData={modalData} companyData={modalData?.data} />
            }
        </React.Fragment >
    );
};

export default PlansPage;
